var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { "margin-left": "10px" },
      attrs: { id: "RequiredManageField" },
    },
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        _vm._l(_vm.projectsData, function (field, index) {
          return _c(
            "Card",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _vm.collapseItemShow
                ? _c(
                    "el-collapse-item",
                    {
                      key: index,
                      staticClass: "my-collapse-item",
                      attrs: { name: field.projectName },
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "18px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(field.projectName))]
                        ),
                      ]),
                      _c(
                        "Form",
                        {
                          ref: field.projectName,
                          refInFor: true,
                          attrs: { model: _vm.model[field.projectName] },
                        },
                        [
                          _vm._l(
                            _vm.getRowElements(
                              field.projectName,
                              field.fieldConfig,
                              field.checkStatus
                            ),
                            function (rowItem, rowIndex) {
                              return [
                                rowItem.isStartIndex
                                  ? _c(
                                      "Row",
                                      _vm._l(
                                        _vm.getColElements(
                                          field.projectName,
                                          rowIndex
                                        ),
                                        function (item, colIndex) {
                                          return item.isShow
                                            ? _c(
                                                "Col",
                                                {
                                                  attrs: {
                                                    span: item.columnNumber
                                                      ? item.columnNumber
                                                      : 6,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "FormItem",
                                                    {
                                                      style: item.width,
                                                      attrs: {
                                                        prop: item.prop,
                                                        label: item.label,
                                                        "label-width":
                                                          item.labelWidth,
                                                        required:
                                                          item.isRequired &&
                                                          item.isRequired == 2,
                                                      },
                                                    },
                                                    [
                                                      !item.element
                                                        ? _c(
                                                            "Input",
                                                            {
                                                              staticStyle: {
                                                                height: "35px",
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                type: item.type,
                                                                placeholder:
                                                                  item.placeholder,
                                                                autocomplete:
                                                                  item.type ===
                                                                  "password"
                                                                    ? "new-password"
                                                                    : "",
                                                                size: item.size,
                                                                disabled: true,
                                                                readonly: true,
                                                                icon: item.icon,
                                                                prefix:
                                                                  item.prefix,
                                                                suffix:
                                                                  item.suffix,
                                                                number:
                                                                  item.number,
                                                                rows: item.rows,
                                                                autosize:
                                                                  item.autosize,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model[
                                                                    field
                                                                      .projectName
                                                                  ][item.prop],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model[
                                                                        field
                                                                          .projectName
                                                                      ],
                                                                      item.prop,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model[field.projectName][item.prop]",
                                                              },
                                                            },
                                                            [
                                                              item.unit
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        slot: "append",
                                                                      },
                                                                      slot: "append",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.unit
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      item.element === "number"
                                                        ? _c(
                                                            "Input",
                                                            {
                                                              staticStyle: {
                                                                height: "35px",
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                type: item.type,
                                                                placeholder:
                                                                  item.placeholder,
                                                                size: item.size,
                                                                disabled: true,
                                                                readonly: true,
                                                                icon: item.icon,
                                                                prefix:
                                                                  item.prefix,
                                                                suffix:
                                                                  item.suffix,
                                                                number:
                                                                  item.number,
                                                                rows: item.rows,
                                                                autosize:
                                                                  item.autosize,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model[
                                                                    field
                                                                      .projectName
                                                                  ][item.prop],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model[
                                                                        field
                                                                          .projectName
                                                                      ],
                                                                      item.prop,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model[field.projectName][item.prop]",
                                                              },
                                                            },
                                                            [
                                                              item.unit
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        slot: "append",
                                                                      },
                                                                      slot: "append",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.unit
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      item.element === "digit"
                                                        ? _c(
                                                            "Input",
                                                            {
                                                              staticStyle: {
                                                                height: "35px",
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                type: item.type,
                                                                placeholder:
                                                                  item.placeholder,
                                                                size: item.size,
                                                                disabled: true,
                                                                readonly: true,
                                                                icon: item.icon,
                                                                prefix:
                                                                  item.prefix,
                                                                suffix:
                                                                  item.suffix,
                                                                number:
                                                                  item.number,
                                                                rows: item.rows,
                                                                autosize:
                                                                  item.autosize,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model[
                                                                    field
                                                                      .projectName
                                                                  ][item.prop],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model[
                                                                        field
                                                                          .projectName
                                                                      ],
                                                                      item.prop,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model[field.projectName][item.prop]",
                                                              },
                                                            },
                                                            [
                                                              item.unit
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        slot: "append",
                                                                      },
                                                                      slot: "append",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.unit
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      item.element ===
                                                      "textarea"
                                                        ? _c("Input", {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              type: "textarea",
                                                              placeholder:
                                                                item.placeholder,
                                                              size: item.size,
                                                              disabled: true,
                                                              readonly: true,
                                                              icon: item.icon,
                                                              prefix:
                                                                item.prefix,
                                                              suffix:
                                                                item.suffix,
                                                              number:
                                                                item.number,
                                                              rows: item.rows,
                                                              autosize:
                                                                item.autosize,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.model[
                                                                  field
                                                                    .projectName
                                                                ][item.prop],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.model[
                                                                      field
                                                                        .projectName
                                                                    ],
                                                                    item.prop,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "model[field.projectName][item.prop]",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      item.element === "select"
                                                        ? _c(
                                                            "Select",
                                                            {
                                                              staticStyle: {
                                                                height: "35px",
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                placeholder:
                                                                  item.placeholder,
                                                                size: item.size,
                                                                disabled: true,
                                                                filterable:
                                                                  item.filterable,
                                                                multiple:
                                                                  item.multiple,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model[
                                                                    field
                                                                      .projectName
                                                                  ][item.prop],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model[
                                                                        field
                                                                          .projectName
                                                                      ],
                                                                      item.prop,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model[field.projectName][item.prop]",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                '\n                            transfer style="height:35px;">\n                      '
                                                              ),
                                                              _vm._l(
                                                                item.option,
                                                                function (
                                                                  opt,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "Option",
                                                                    {
                                                                      key: index,
                                                                      attrs: {
                                                                        value:
                                                                          opt.value,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          opt.label
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                      item.element ===
                                                      "cascader"
                                                        ? _c("MyCascader", {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              size: item.size,
                                                              disabled: true,
                                                              placeholder:
                                                                item.placeholder,
                                                              options:
                                                                item.option,
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.model[
                                                                  field
                                                                    .projectName
                                                                ][item.prop],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.model[
                                                                      field
                                                                        .projectName
                                                                    ],
                                                                    item.prop,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "model[field.projectName][item.prop]",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      item.element === "date"
                                                        ? _c("DatePicker", {
                                                            staticStyle: {
                                                              height: "35px",
                                                              width: "100%",
                                                            },
                                                            style:
                                                              item.elemWidth,
                                                            attrs: {
                                                              editable: false,
                                                              type: item.type,
                                                              options:
                                                                item.options,
                                                              format:
                                                                item.format,
                                                              placeholder:
                                                                item.placeholder,
                                                              size: item.size,
                                                              disabled: true,
                                                              transfer: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.model[
                                                                  field
                                                                    .projectName
                                                                ][item.prop],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.model[
                                                                      field
                                                                        .projectName
                                                                    ],
                                                                    item.prop,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "model[field.projectName][item.prop]",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      item.element === "time"
                                                        ? _c("TimePicker", {
                                                            staticStyle: {
                                                              height: "35px",
                                                              width: "100%",
                                                            },
                                                            style:
                                                              item.elemWidth,
                                                            attrs: {
                                                              type: item.type,
                                                              format:
                                                                item.format,
                                                              placeholder:
                                                                item.placeholder,
                                                              size: item.size,
                                                              disabled: true,
                                                              transfer: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.model[
                                                                  field
                                                                    .projectName
                                                                ][item.prop],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.model[
                                                                      field
                                                                        .projectName
                                                                    ],
                                                                    item.prop,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "model[field.projectName][item.prop]",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      item.element === "radio"
                                                        ? _c(
                                                            "RadioGroup",
                                                            {
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                type: item.type,
                                                                size: item.size,
                                                                vertical:
                                                                  item.vertical,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model[
                                                                    field
                                                                      .projectName
                                                                  ][item.prop],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model[
                                                                        field
                                                                          .projectName
                                                                      ],
                                                                      item.prop,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model[field.projectName][item.prop]",
                                                              },
                                                            },
                                                            _vm._l(
                                                              item.option,
                                                              function (
                                                                opt,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "Radio",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      label:
                                                                        opt.value,
                                                                      size: item.size,
                                                                      disabled: true,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        opt.label
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      item.element ===
                                                      "checkbox"
                                                        ? _c("MyCheckBox", {
                                                            key:
                                                              item.prop + index,
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              enumList:
                                                                item.option,
                                                              dataStr:
                                                                _vm.model[
                                                                  field
                                                                    .projectName
                                                                ][item.prop],
                                                              disabled: true,
                                                            },
                                                            on: {
                                                              "update:dataStr":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$set(
                                                                    _vm.model[
                                                                      field
                                                                        .projectName
                                                                    ],
                                                                    item.prop,
                                                                    $event
                                                                  )
                                                                },
                                                              "update:data-str":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$set(
                                                                    _vm.model[
                                                                      field
                                                                        .projectName
                                                                    ],
                                                                    item.prop,
                                                                    $event
                                                                  )
                                                                },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }